module.exports = __webpack_public_path__ + "media/教室2.1441509e.mp4";